import { FC } from "react";

import { GoodbyePage } from "../pages";

const GoodbyeRoute: FC<{}> = () => {

    return (
        <div>
            <GoodbyePage />
        </div>
    );
}

export default GoodbyeRoute;